module.exports = __webpack_public_path__ + "static/img/kamsky.dc80bdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/kamsky.jpg
// module id = 481
// module chunks = 11